import React from 'react';

function PlayIcon({ handleClick, extraClasses, height, width }) {
  return (
    <div
      role="img"
      onClick={handleClick}
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
        <svg width={width} height={height} viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Play Icon" fillRule="evenodd" clipRule="evenodd" d="M0 0V6.03738L3.5 3.01869L0 0Z" fill="white"/>
        </svg>
    </div>
  );
}

export default PlayIcon;